import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import moment from 'moment';
import axios from "axios";
import 'moment/locale/de'
import "./events.scss";

moment.locale('de')

const Events = ({ visibleEvents }) => {
    const [eventData, setEventData] = useState(null);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {

        const fetchData = async () => {
            try {
                const eventsRes = await axios.get('https://mk-lorenzen.it/konzertmeisterApi.php');
                setEventData(eventsRes.data);

                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    return (
        <div className='events'>
            <div className="container">
                <h1>Auftritte und Termine</h1>
                <div className="list">
                    {isLoading ? <div className='loading' /> : eventData.slice(0, visibleEvents).map((item, index) => {
                        const delay = (index % 5) * 0.1;

                        return (
                            <motion.div
                                className="item"
                                key={item.id}
                                initial={{ opacity: 0, y: 100 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay }}
                            >
                                <div className="left">
                                    <span className='day'>{moment(item.start).format('DD')}</span>
                                    <span className='month'>{moment(item.start).format('MMM YY')}</span>
                                </div>
                                <div className="right">
                                    <h3>{item.name}</h3>
                                    <span>{!item.timeUndefined && (moment(item.start).format('HH:mm') + " - " + moment(item.end).format('HH:mm'))}</span>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
                {visibleEvents && (
                    <Link to={"/kapelle/auftritte"}>
                        <button className="loadMore">Mehr anzeigen</button>
                    </Link>
                )}
            </div>
        </div>
    )
}

export default Events;
